import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
 const firebaseConfig = {
  apiKey: "AIzaSyA6-UarcwkIodOnoKViVBjVvTnqe9g_45Q",
  authDomain: "greenmind-f72f8.firebaseapp.com",
  projectId: "greenmind-f72f8",
  storageBucket: "greenmind-f72f8.appspot.com",
  messagingSenderId: "718111830526",
  appId: "1:718111830526:web:2090479097d68e56e590af",
  measurementId: "G-XVHQL7B874"
  };
  
  const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };